export default __webpack_public_path__ + "static/media/logo_biotech.243d3044.svg";